import type { FC } from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import styled from "styled-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { Label } from "app/pages/industry-analysis/home/enriched-custom-industries/commonStyled";
import { ChangeValue } from "@similarweb/ui-components";
import { percentageSignFilter } from "app/filters/ngFilters";
import { Container } from "app/pages/industry-analysis/home/enriched-custom-industries/TrafficAndEngagementData/commonStyled";
import { colorsPalettes } from "@similarweb/styles";

const { carbon } = colorsPalettes;

const ChangeValueContainer = styled(FlexRow)`
    height: 100%;
    align-items: center;
    color: ${carbon[500]};
`;

interface IPeriodChange {
    periodChange?: number;
}

export const PeriodChange: FC<IPeriodChange> = (props) => {
    const { periodChange } = props;
    const i18n = i18nFilter();
    return (
        <Container>
            <ChangeValueContainer>
                <ChangeValue
                    unsigned={periodChange === 0 || !periodChange}
                    value={percentageSignFilter()(periodChange, 2)}
                    isDecrease={periodChange < 0}
                />
            </ChangeValueContainer>

            <Label>{i18n("industry.research.homepage.benchmark.month.over.month.change")}</Label>
        </Container>
    );
};
